import script from "./DefaultLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts&setup=true"

import "./DefaultLayout.vue?vue&type=style&index=0&id=477f8758&lang=scss&scoped=true"

import exportComponent from "/Users/BlackPaw/Developer/acebed_vue3_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-477f8758"]])

export default __exports__